export const MANAGE_EOB_MESSAGE = {
  title: "Manage EOBs",
  defaultDescription: "Access electronic EOBs in application and portal",
  physicalEobCheckboxDescription: "Receive EOBs by Mail",
  positiveButtonLabel: "Save Changes",
  negativeButtonLabel: "Cancel",

  successStatus: "Success",
  failureStatus: "Failed",

  virtualStatusMessage: "You will now only receive electronic EOBs",
  physicalStatusMessage:
    "You will now receive EOBs by mail in addition to electronic EOBs",
  errorStatusMessage: "Something went wrong. Please try again.",

  acknowledgeButtonLabel: "OK",
};
